import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Auth, User } from '../../services/schemas/authServiceSchemas';

interface AuthState {
    user: User | null;
    accessToken: string | null;
    refreshToken: string | null;
    idToken: string | null;
    isAuthenticated: boolean;
    isLoading: boolean;
}

const getInitialState = (): AuthState => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const idToken = localStorage.getItem('idToken');

    return {
        user: null,
        accessToken,
        refreshToken,
        idToken,
        isAuthenticated: !!accessToken,
        isLoading: !!accessToken
    };
};

const authSlice = createSlice({
    name: 'auth',
    initialState: getInitialState(),
    reducers: {
        setCredentials: (state, action: PayloadAction<Auth>) => {
            state.user = action.payload.user;
            state.accessToken = action.payload.accessToken;
            state.idToken = action.payload.idToken;
            if (action.payload.refreshToken) {
                state.refreshToken = action.payload.refreshToken;
                localStorage.setItem('refreshToken', action.payload.refreshToken);
            }
            state.isAuthenticated = true;
            localStorage.setItem('accessToken', action.payload.accessToken);
            localStorage.setItem('idToken', action.payload.idToken);
        },
        setUser: (state, action: PayloadAction<User>) => {
            state.user = action.payload;
            state.isAuthenticated = true;
        },
        clearAuth: (state) => {
            state.user = null;
            state.accessToken = null;
            state.idToken = null;
            state.refreshToken = null;
            state.isAuthenticated = false;
            localStorage.removeItem('accessToken');
            localStorage.removeItem('idToken');
            localStorage.removeItem('refreshToken');
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        }
    }
});

export const { setCredentials, setUser, clearAuth, setLoading } = authSlice.actions;
export default authSlice.reducer;
